import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';

// sockjs-client expects Node's `global` in the browser
if (typeof window !== 'undefined' && typeof window.global === 'undefined') {
  window.global = window;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
